import { render } from "./BlackOilTable.vue?vue&type=template&id=8f95db3a"
import script from "./BlackOilTable.vue?vue&type=script&lang=js"
export * from "./BlackOilTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__